import React from 'react';

import { Inject } from '@odinjs/odin';

import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import { FetchAPI, FieldAPI, LegendsAPI, Link, PanelAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnCancel, OnClose, OnDynamicContentRender, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, RenderEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames } from '../../codegen';
import { NegotiationMaterialsAliases as Aliases } from '../../codegen/constants/aliases/negotiation-materials-aliases';
import BaseController from '../BaseController';

import { Item } from './negotiation-procedures-controller';
import './negotiation-materials.css';

const MATERIAL = 'M';

interface Material {
  dsItem: string,
  edit: string,
  vlMaterial: number,
  nrSeqItemProposal: number,
  vlCpMaterial: number,
  ieValueCounterProposal: string,
}

@Controller({ fragment: FragmentNames.NEGOTIATION_MATERIALS })
class NegotiationMaterialsController extends BaseController {

  @Inject(Aliases.FETCH_MATERIALS)
  private fetchMaterials: FetchAPI;
  @Inject(Aliases.PANEL_MODAL_MATERIAL)
  private panelModal: PanelAPI;
  @Inject(Aliases.LEGENDS)
  private legends: LegendsAPI;

  @OnMount(Aliases.FETCH_MATERIALS)
  onMountFetch(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqProposal, nrSeqNegotiation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqNegotiation, nrSeqProposal, 'itemType': MATERIAL });
    api.setParameters({ nrSeqNegotiation, nrSeqProposal, 'itemType': MATERIAL });
    api.forceFetch();
  }

  @OnMount(Aliases.FIELD_COUNTER_OFFER_VALUE)
  onMountFieldCounterOfferValue(event: MountEvent): void {
    const api = event.target as FieldAPI;
    const data = api.getData();
    if (data) {
      const { vlCpMaterial } = data as unknown as Material;
      if (vlCpMaterial > 0) {
        api.setVisible(true);
      }
    }
  }

  @OnAfterFetch(Aliases.FETCH_MATERIALS)
  onAfterFetchMaterials(event: FetchEvent): void {
    const data = event.data as Material[];
    if (!data || data.length === 0) {
      this.legends.setShowExpression('');
      this.legends.setHideExpression('');
    }
  }

  @OnDynamicContentRender(Aliases.CARD_MATERIAL)
  onRenderLinkEdit(event: RenderEvent): void {
    const { render, data } = event;
    const { edit, nrSeqItemProposal } = data as Item;
    if (edit == 'S') {
      render(() =>
        <Link
          className="link-negotiation-materials__button_align"
          onClick={() => this.onOpenEditProposal(nrSeqItemProposal)}
          value={MessageService.translate('provider.change-value')}
        />
      );
    }
  }

  @OnSubmit(Aliases.FORM_MATERIAL)
  onSubmitMaterial(event: SubmitEvent): void {
    const body = { ...event.record, 'itemType': MATERIAL };
    const { nrSeqProposal, nrSeqNegotiation } = this.historyService.getCurrentRouteParams();

    HttpService.post(Endpoint.POST.EDIT_NEGOTIATION_PROPOSAL_ITEM, { nrSeqProposal, nrSeqNegotiation }, { body })
      .then(() => {
        this.fetchMaterials.forceFetch();
        this.panelModal.setVisible(false);
        ToastService.open({ message: MessageService.translate('provider.succes-change'), level: ToastLevel.SUCCESS });
      }).catch(() => {
        ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR });
      });
  }

  @OnClose(Aliases.MODAL_MATERIAL)
  onCloseModal(): void {
    this.panelModal.setVisible(false);
  }

  @OnCancel(Aliases.FORM_MATERIAL)
  onCancelCounterOffer(): void {
    this.panelModal.setVisible(false);
  }

  onOpenEditProposal(nrSeqItemProposal: number): void {
    this.context.set({ nrSeqItemProposal });
    this.panelModal.setVisible(true);
  }

}

export default NegotiationMaterialsController;
